export class BookingAddOn {
	optionId: string;
	amount: number;
	optionPrice: number;
	optionName: string;
	gstExempt: boolean;
	adjustedBySystem: boolean;

	constructor(data: Partial<BookingAddOn>) {
		Object.assign(this, data);
	}
}

export function hasAddOnsChanged(newAddOns: BookingAddOn[], oldAddOns: BookingAddOn[]): boolean {
	const optionIds = new Set<string>();

	for (const option of newAddOns) {
		optionIds.add(option.optionId);
	}
	for (const option of oldAddOns) {
		optionIds.add(option.optionId);
	}

	if (optionIds.size !== newAddOns.length) {
		return true;
	}

	// Check amount of each option
	for (const optionId of optionIds.values()) {
		const optionFromNew = newAddOns.find(x => x.optionId === optionId);
		const optionFromOld = oldAddOns.find(x => x.optionId === optionId);
		if (optionFromNew?.amount !== optionFromOld?.amount) {
			return true;
		}
	}

	return false;
}
